export let FLAVOUR = 'US';
export let currencyName = FLAVOUR == 'US' ? 'USD' : 'AED';
export let vatRate = FLAVOUR == 'US' ? 0 : 5;
export let PUBLIC_KEY = FLAVOUR == 'US' ? 'pk_live_GPYyng5ltUAWm3BPLa2I9PZA00hm1Z4NuD' : 'pk_live_51IlthDHiyE12MEiRW7s30uWqACBAZ0TXfpom4QI8uoIQPP0TE4kPMQYgVDJnPqP7MdLYpSwqIBK7uluj5fSe3tGY00UAtqASg0';


// "pk_test_51IlthDHiyE12MEiRkZdESE219L9uU0KpidQRnpfaCn5f5lO5Vtimud99nAln5j0MqN6HwFcDQySiem0b3jUairPc0088Jj0KZr"
// export let FLAVOUR='UAE'


// clickable Categories in side bar && add phone number to continue register for guest 
